import angular from "angular";

angular
    .module('app')
    .component('courseGroupStudents', {
        template: require('./course-group-students.html'),
        controller: ['$http', 'Notifier', '$uibModal', 'moment', '$timeout', controller],
        bindings: {
            course: '<',
            courseGroup: '<',
            lessons: '<',
            // chapters: '<',
        }
    });

function controller($http, Notifier, $uibModal, moment, $timeout) {

    let $ctrl = this;

    $ctrl.page = 1;
    $ctrl.perPage = '20';

    $ctrl.search = null;
    $ctrl.activeLessonId = null;

    $ctrl.$onInit = function () {
        $ctrl.getList();
    };

    $ctrl.getList = function () {
        $http
            .get(`/admin/course-groups/${$ctrl.courseGroup.id}/get-students`, {
                params: {
                    page: $ctrl.page,
                    per_page: $ctrl.perPage,
                    search: $ctrl.search,
                    active_lesson_id: $ctrl.activeLessonId,
                }
            })
            .then(
                function (response) {
                    $ctrl.students = response.data.data;
                    $ctrl.total = response.data.total;
                    $ctrl.students.forEach(function (student, ind) {
                        student.number = ($ctrl.page - 1) * $ctrl.perPage + ind + 1;
                        student.activeLesson = getStudentActiveLesson(student);
                    });
                },
                function (error) {
                }
            );
    };

    function getStudentActiveLesson(student) {
        let lessonStatus = student.lesson_statuses.find(v => v.status == 'active');
        if (lessonStatus) {
            return $ctrl.lessons.find(v => v.id == lessonStatus.lesson_id);
        }
    }

    $ctrl.doFilter = function () {
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.resetFilter = function () {
        $ctrl.search = null;
        $ctrl.activeLessonId = null;
        $ctrl.page = 1;
        $ctrl.getList();
    };

    $ctrl.openAttachModal = function () {

        $ctrl.resetFilter();

        $uibModal
            .open({
                component: 'courseGroupStudentsAttachModal',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    course: function () {
                        return $ctrl.course;
                    },
                    courseGroup: function () {
                        return $ctrl.courseGroup;
                    }
                }
            })
            .result
            .then(
                function (students) {

                    students.forEach(function (student) {
                        student.pivot = {created_at: moment()};

                        student.lesson_statuses = [];

                        $ctrl.lessons.forEach(function (lesson, ind) {
                            student.lesson_statuses.push({
                                lesson_id: lesson.id,
                                status: ind ? 'closed' : 'active'
                            });
                        });

                        $ctrl.students.push(student);
                    });

                    $ctrl.total += $ctrl.students.length;
                },
                function (error) {

                }
            );
    };

    $ctrl.openStudentLessonsControl = function (student) {
        $uibModal
            .open({
                component: 'studentLessonsControl',
                resolve: {
                    student: function () {
                        return student;
                    },
                    course: function () {
                        return $ctrl.course;
                    },
                    lessons: function () {
                        return $ctrl.lessons;
                    }
                },
                size: 'lg',
            })
            .result
            .then(
                function () {

                },
                function () {
                },
            )
    };

    $ctrl.openLessonStatusChangeModal = function () {

        let students = $ctrl.students.filter(v => v.isSelected);

        $uibModal
            .open({
                component: 'groupLessonStatusChangeModal',
                resolve: {
                    students: function () {
                        return students;
                    },
                    lesson: function () {
                        return $ctrl.lesson;
                    }
                }
            })
            .result
            .then(
                function () {

                },
                function () {

                }
            );
    };

    $ctrl.openLesson = function (lesson) {
        lesson.openLoading = true;
        $http
            .post(`/admin/course-groups/${$ctrl.courseGroup.id}/open-lesson`, {
                lesson_id: lesson.id
            })
            .then(
                function (response) {
                    lesson.openLoading = false;
                    lesson.opened = true;
                },
                function (error) {
                    lesson.openLoading = false;
                }
            );
    };



    /*
     let selectedStudents = $ctrl.students.filter(v => v.isSelected);

        selectedStudents.forEach(function (student) {
            $http
                .post(`/admin/users/${student.id}/set-lesson-status`, {
                    lesson_id: $ctrl.lesson.id,
                    status: $ctrl.status,
                })
                .then(
                    function (response) {

                    },
                    function (error) {

                    }
                );
        });
     */
}
